import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35bbd505"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seperator" }, " - ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seperator" }, " - ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seperator" }, " - ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seperator" }, " - ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seperator" }, " - ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LightBulbIcon = _resolveComponent("LightBulbIcon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      "exact-active-class": _ctx.store.dark ? 'exact-active' : 'exact-activeLight',
      class: _normalizeClass(_ctx.store.dark ? 'menuItem': 'menuItemLight')
    }, {
      default: _withCtx(() => [
        _createTextVNode(" this is adam ryan ")
      ]),
      _: 1
    }, 8, ["exact-active-class", "class"]),
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: "/portfolio",
      class: _normalizeClass(_ctx.store.dark ? 'menuItem': 'menuItemLight'),
      "exact-active-class": "exact-active"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" portfolio ")
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_3,
    _createVNode(_component_router_link, {
      to: "/resume",
      class: _normalizeClass(_ctx.store.dark ? 'menuItem': 'menuItemLight'),
      exact: "",
      "exact-active-class": "exact-active"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" resume ")
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_4,
    _createVNode(_component_router_link, {
      to: "/future",
      class: _normalizeClass(_ctx.store.dark ? 'menuItem': 'menuItemLight'),
      exact: "",
      "exact-active-class": "exact-active"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" future ")
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_5,
    _createVNode(_component_router_link, {
      to: "/contact",
      class: _normalizeClass(_ctx.store.dark ? 'menuItem': 'menuItemLight'),
      exact: "",
      "exact-active-class": "exact-active"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" contact ")
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_6,
    _createElementVNode("div", {
      class: _normalizeClass(["menuItemSwitch", _ctx.store.dark ? 'menuItemSwitch': 'menuItemSwitchLight']),
      exact: "",
      "exact-active-class": "exact-active",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.store.changeTheme && _ctx.store.changeTheme(...args)))
    }, [
      _createVNode(_component_LightBulbIcon, { class: "icon" }),
      _createTextVNode(" Dark/Light ")
    ], 2)
  ]))
}